import { blockedCameraLabels } from '@/resources/application';

const blockedCameraRegex = blockedCameraLabels.map((label) => new RegExp(label, 'i'));

function isVideoDevice(device: MediaDeviceInfo) {
  return device.kind === 'videoinput';
}

function isAllowedCameraLabel(device: MediaDeviceInfo) {
  // o(n^3)だけどdevices,blockedCameraLabelsの数は限られてるので計算量は問題なさそう
  return !blockedCameraRegex.some((re) => re.test(device.label));
}

export function isAllowedDevice(device: MediaDeviceInfo) {
  return isVideoDevice(device) && isAllowedCameraLabel(device);
}
